import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const HealthProtocolIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="M21.32,5.67a2.06,2.06,0,0,0-.61-1.48,2,2,0,0,0-1.49-.62h-1V1.47H16.06v2.1H7.64V1.47H5.53v2.1h-1A2,2,0,0,0,3,4.19a2,2,0,0,0-.62,1.49h0V20.42A2,2,0,0,0,3,21.91a2,2,0,0,0,1.49.62H19.22a2.12,2.12,0,0,0,2.11-2.11V5.68h0Zm-16.84,0H19.21v2.1H4.48ZM19.22,20.42H4.48V11h0V9.9H19.21V11h0Z" />
      <path d="M10.72,16.29v3.39H13V16.29h3.39V14H13V10.64H10.72V14H7.33v2.26Z" />
    </SvgIcon>
  )
}

export default HealthProtocolIcon
